import React, { useState, useEffect } from 'react';
import { LayoutProvider } from 'app-template-lib/hooks';
import { AppProvider } from 'app-template-lib/hooks';
import { Main } from '../main';
import { IRoute } from 'app-template-lib/utils';
import { TContentsContentParams, TContentsHeaderParams } from '../../shared/t-contents-params';
import { Layout } from 'app-template-lib/components/layout-column';
import { IMain } from 'app-template-lib/utils';
import { Features } from '../../features';
import { useLocation } from 'react-router-dom';
import NotFoundPage from './404/notfound.container';
import HeaderPresenter from './header.presenter';
import { useQuery } from '@apollo/client';
import { FETCH_M_LG_CONFIG } from '../queries/setting_m_lg_config.queries.type';
import setting_m_lg_configQueries from '../queries/setting_m_lg_config.queries';

/**
 * メインコンテナ　システムレイアウトを定義します
 * @returns
 */
export default function MainContainer() {
    const [defaultMain, setDefaultMain] = useState<IMain<TContentsHeaderParams, TContentsContentParams> | null>(null);
    const [routers, setRouters] = useState<IRoute<TContentsHeaderParams, TContentsContentParams>[]>([]);
    const [topNavItems, setTopNavItems] = useState<React.ReactNode[]>([]);
    const { data } = useQuery<FETCH_M_LG_CONFIG>(setting_m_lg_configQueries.FETCH_M_LG_CONFIG, {
        onError: (error) => console.error(error.message),
        fetchPolicy: 'cache-first',
    });
    const location = useLocation();
    const pathnames = location.pathname.split('/');
    const lgcode = pathnames[2];

    useEffect(() => {
        //ホストのインスタンスを作成
        const main = new Main('');
        // Featureを取得
        const features = Features;
        // Featureを初期化
        main.initializeFeatuers(features);
        //ルーターを作成します。
        const myRouters = main.createRouter(features);
        const myTopNavs = main.createTopAction(features);
        setRouters(myRouters);
        setTopNavItems(myTopNavs);
        setDefaultMain(main);
    }, []);

    // データがまだ取得できていない場合、何も表示しない
    if (!defaultMain || !data) {
        return <></>;
    }

    // lgcode が一致しない場合、NotFound を表示
    if (lgcode !== data.setting_m_lg_config[0]?.lgcode) {
        return <NotFoundPage />;
    }

    return (
        <>
            <AppProvider defaultMain={defaultMain}>
                <LayoutProvider defaultSideNav={[]} defaultSideUser={null} defaultTopNav={topNavItems}>
                    <Layout routers={routers} header={<HeaderPresenter data={data} />} />
                </LayoutProvider>
            </AppProvider>
        </>
    );
}
